<fin-booking-plain-header-area [title]="'MMB.view.changeFlightsModal.subTitle' | finLocalization">
</fin-booking-plain-header-area>
<div
  *ngFor="let bound of booking$ | finMap: 'bounds' | async; index as i; first as isFirst; last as isLast"
  class="ps-large-b"
>
  <fcom-bound-selection-item
    [disabled]="!(changeableBoundIds$ | async | finIncludes: bound.id)"
    [bound]="bound"
    [locations]="(booking$ | async).locations"
    [isDeparture]="isFirst"
    [flightNumber]="i + 1"
    [tails]="getTails(bound)"
    [isSelected]="selectedBoundsForChange$ | async | finIncludes: bound.id"
    [notification]="boundNotifications$ | finMap: bound.id | async"
    (boundSelected)="isLast ? toggleInbound(bound) : toggleOutbound(bound)"
  ></fcom-bound-selection-item>
</div>
<div buttons>
  <fcom-cta-button
    data-testid="manage-booking-select-bound-cta-button"
    [disabled]="(selectedBoundsForChange$ | async)?.length > 0 === false"
    [title]="'actions.continue' | finLocalization"
    (click)="continue()"
    [position]="ButtonPosition.GRID_FULL"
    [layout]="ButtonLayout.COLUMN"
  ></fcom-cta-button>
</div>
